import styled from 'styled-components';

import { DESKTOP_BP } from 'src/_AppContainer';
import * as mx from 'core/styles/mixins';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.global.module.color};
	padding: 64px 0 36px;
`;

export const LinksContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 64px;

	hr {
		margin: 64px 0;
	}

	${mx.bp(DESKTOP_BP)`
		flex-direction: row;

		hr {
			display: none;
		}
	`}
`;

export const DisclaimerContainer = styled.div`
	hr {
		margin: 0 0 24px;
	}
`;

export const LinkList = styled.ul`
	${mx.listReset}
	min-width: 300px;

	${mx.bp(DESKTOP_BP)`
		margin-right: 60px;
	`}

	a {
		text-decoration: none;
		font-size: 14px;
		line-height: 24px;

		&:focus,
		&:hover {
			text-decoration: underline;
		}
	}
`;

export const LinkListItem = styled.li`
	margin: 0 0 12px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const MaintenanceApiContainer = styled.div`
	display: none;
`;
